import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import clientAccess from "../../../locales/en_GB/clientAccess.json";
import clientLifecycle from "../../../locales/en_GB/clientLifecycle.json";
import common from "../../../locales/en_GB/common.json";
import commonServices from "../../../locales/en_GB/commonServices.json";
import customerAccount from "../../../locales/en_GB/customerAccount.json";
import instrumentIssuance from "../../../locales/en_GB/instrumentIssuance.json";
import portal from "../../../locales/en_GB/portal.json";
import sandbox from "../../../locales/en_GB/sandbox.json";

export const initI18n = () =>
  i18n.use(initReactI18next).init({
    load: "currentOnly",
    supportedLngs: ["en_GB"],
    interpolation: {
      escapeValue: false,
    },
    defaultNS: "common",
    ns: [
      "common",
      "instrumentIssuance",
      "clientLifecycle",
      "customerAccount",
      "commonServices",
      "clientAccess",
      "portal",
      "sandbox",
    ],
    fallbackLng: "en_GB",
    returnEmptyString: false,
    resources: {
      en_GB: {
        common,
        instrumentIssuance,
        clientLifecycle,
        customerAccount,
        commonServices,
        clientAccess,
        portal,
        sandbox,
      },
    },
  });
